(() => {
  if (window.FGMessageSelector) return;
  window.FGMessageSelector = true;
  const instances = new WeakMap();
  const within = (root) => [
    ...(root.matches?.('[data-fg-messages]') ? [root] : []),
    ...root.querySelectorAll('[data-fg-messages]'),
  ];
  const init = (root) => within(root).forEach((section) => {
    if (instances.has(section)) return;
    // The shared original deck controller owns navigation and swipe motion.
    // Its cycling tab copies are visual controls, not extra accessible tabs.
    section.querySelectorAll('[data-fg-selector-clone]').forEach((clone) => {
      clone.removeAttribute('id');
      clone.removeAttribute('aria-controls');
      clone.removeAttribute('aria-selected');
    });
    const cards = [...section.querySelectorAll('[data-fg-selector-card]')];
    const tabs = [...section.querySelectorAll('[data-fg-selector-tab]:not([data-fg-selector-clone])')];
    const count = section.querySelector('[data-fg-message-count]');
    const status = section.querySelector('[data-fg-message-status]');
    let selectedId;
    const update = () => {
      const active = cards.find((card) => card.classList.contains('is-active'));
      if (!active || selectedId === active.dataset.fgCardId) return;
      selectedId = active.dataset.fgCardId;
      if (count) count.textContent = `${String(cards.indexOf(active) + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
      if (status) status.textContent = `${section.dataset.selectedLabel}: ${tabs.find((tab) => tab.dataset.fgCardId === selectedId)?.textContent.trim() || ''}`;
    };
    const observer = new MutationObserver(update);
    cards.forEach((card) => observer.observe(card, { attributes: true, attributeFilter: ['class'] }));
    const selectBlock = (event) => {
      const card = event.target.closest('[data-fg-selector-card]');
      const id = event.detail?.blockId || card?.dataset.fgCardId;
      tabs.find((tab) => tab.dataset.fgCardId === id)?.click();
    };
    section.addEventListener('shopify:block:select', selectBlock);
    instances.set(section, () => {
      observer.disconnect();
      section.removeEventListener('shopify:block:select', selectBlock);
      instances.delete(section);
    });
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => within(event.target).forEach((section) => instances.get(section)?.()));
})();
